var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.126 13.567c.156 2.503 1.46 4.797 2.816 7.196.73 1.252 1.46 2.556 2.033 3.91.053.157.053.314 0 .417-.05.104-.104.208-.26.26a22.022 22.022 0 01-8.708 1.774c-2.972 0-5.891-.626-8.707-1.773-.104-.051-.208-.104-.26-.26-.053-.157-.053-.314 0-.417.521-1.355 1.303-2.66 2.033-3.911 1.355-2.399 2.66-4.693 2.816-7.196zM17.136 1c.314 0 .523.21.523.522v2.294l1.304 1.877c.104.105.104.261.104.366l-.835 6.413H9.838l-.886-6.413a.96.96 0 01.103-.366l1.25-1.825V1.522c0-.313.21-.522.522-.522.314 0 .522.21.575.522v2.294l2.607 2.815 2.606-2.815V1.522c0-.313.21-.522.522-.522z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}

export default SvgDress;